// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".wrapper{display:grid;grid-template-columns:1fr .5fr;grid-gap:4px}.together{position:relative}.subject-attributes{position:absolute;bottom:0px;right:0px}.attributes{position:absolute;bottom:5px;right:5px}.option-panel{background-color:#f5f5f5;padding:10px}.advanced-options{background-color:#f5f5f5;padding:10px}.editor{background-color:#fff}.subject-form-container{z-index:1}", ""]);
// Exports
module.exports = exports;
